import {call, fork, put, select, take, takeEvery} from 'redux-saga/effects';

import {push} from 'connected-react-router';

import {
    AUTHENTICATE_USER,
    GET_USER_DATA_REQUESTED,
    GET_USER_SYSTEM_NOTIFICATIONS_REQUESTED,
    USER_LOGOUT_REQUEST,
} from './actionTypes';
import {
    getUserDataFailed,
    getUserDataSucceeded,
    getUserSystemNotificationsFailed,
    getUserSystemNotificationsSucceeded,
    insertSystemNotification,
} from './action';
import {destroyChat} from '../chat/action';
import {fetchUser, fetchUserSystemNotifications, logOutUser as logOutRequest} from './api';
import {getUser} from '../sagaUtils';
import {addNotification} from '../notification/action';

import config from '../../config';
import {getUserByEmail} from "../company/api";
import {eventChannel} from "redux-saga";
import SockJS from "sockjs-client";
import Stomp from "stompjs";

function* authenticateUser() {
    try {
        yield put(push('/dashboard'));
    } catch (error) {
        yield put(addNotification('somethingWentWrong', config.notificationLevels.error, {}));
    }
}

function* logoutUser() {
    logOutRequest().then(() => window.location.href = config.APP_HOST + "/login");
    yield put(destroyChat());
}

function initSystemNotificationsWebSocket(userId) {
    return eventChannel((emitter) => {
        const socket = new SockJS(`${config.BACKEND_HOST}/ws`);
        const stompClient = Stomp.over(socket);
        stompClient.debug = null;

        stompClient.connect({}, () => {
            stompClient.subscribe(`/chat/${userId}/company/system-notification`, emitter);
        }, (error) => {
            console.log(error);
        });

        return () => {
            stompClient.disconnect();
        };
    });
}

function* initSystemNotificationsWebSocketHandling(channel) {
    while (true) {
        const event = yield take(channel);
        const notification = JSON.parse(event.body);
        if (notification) {
            yield put(insertSystemNotification(notification));
            yield put({ type: 'PLAY_NEW_SYSTEM_NOTIFICATION_SOUND' });
        }
    }
}

function* getUserSystemNotifications() {
    try {
        let userSystemNotificationsData = yield call(fetchUserSystemNotifications);
        yield put(getUserSystemNotificationsSucceeded(userSystemNotificationsData));
    } catch (e) {
        yield put(getUserSystemNotificationsFailed(e));
    }
}

function* getUserData() {
    try {
        // from auth
        const userTokenInitializedData = yield select(getUser);
        let userData = yield call(fetchUser, userTokenInitializedData.id);
        //

        // from chat-backend
        let user;
        try {
            user = yield call(() => getUserByEmail(userData.email));
        } catch (err) {
            if (err.response && err.response.status === 500) {
                document.cookie = "jwt-access-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                window.location.href = config.APP_HOST + '/login';
                return;
            } else {
                throw err;
            }
        }
        //

        // merge
        userData = {...user, ...userData};
        userData.postgresId = user.id
        //

        try {
            const socketChannel = yield call(initSystemNotificationsWebSocket, userData.id);
            yield fork(initSystemNotificationsWebSocketHandling, socketChannel);
        } catch (e) {
            console.error(e)
        }

        yield put(getUserDataSucceeded(userData));
    } catch (e) {
        yield put(getUserDataFailed(e));
    }
}

function* watchUser() {
    yield takeEvery(AUTHENTICATE_USER, authenticateUser);
    yield takeEvery(USER_LOGOUT_REQUEST, logoutUser);
    yield takeEvery(GET_USER_DATA_REQUESTED, getUserData);
    yield takeEvery(GET_USER_SYSTEM_NOTIFICATIONS_REQUESTED, getUserSystemNotifications);
}

export default watchUser;



// WEBPACK FOOTER //
// ./src/services/user/saga.js